import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "edit--sprite",
  "use": "edit--sprite-usage",
  "viewBox": "0 0 25 25.1",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25.1\" id=\"edit--sprite\"><title>Edição</title><path id=\"edit--sprite_Path_135\" data-name=\"Path 135\" d=\"M22.17,0H2.93A3,3,0,0,0,0,2.93V22.07a3,3,0,0,0,2.93,3H22.07A2.92,2.92,0,0,0,25,22.18h0V2.93A2.82,2.82,0,0,0,22.25,0ZM7.11,22h-4V18L14.75,6.49l4,4ZM21.65,7.32,19.77,9.2l-4-4,2-1.78a1,1,0,0,1,1.43,0l0,0,2.41,2.41a1,1,0,0,1,0,1.43Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol